export default function PageLoader() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background-50">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-background-200 border-t-primary-500" />
        <p className="font-body text-sm text-foreground-500">Cargando…</p>
      </div>
    </div>
  );
}